import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Link} from "react-router-dom";
import Translate from "../MultiLanguage/Translate"

const HeaderAccountsPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const navigate = useNavigate();
  const location = useLocation();
  const redirectPage =projectInfo?.projectConfig?.config?.INITIAL_PAGE
  return (
    <header className="accountsPageHeader">
      <div className="left">
        <div className="logoContainer">
          <Link to={redirectPage==="LOGIN"?"/login":"/home"}>
            <h1>
              <img src={projectInfo?.projectConfig?.config?.LOGO} alt="Logo" />
            </h1>
          </Link>
        </div>
      </div>
      <div className="right">
        {location?.pathname === "/register" ? (
          <button onClick={() => navigate("/login")}><Translate textKey={'login'} /></button>
        ) : (
          // <button onClick={() => navigate("/register",{ state: { ...location.state },})}><Translate textKey={'register'} /></button>
          <button onClick={() => navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? "/checkout" : "/register", { state: { ...location.state }, })}>
            {projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT ?  <Translate textKey={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT}/> : <Translate textKey={'register'} />}
          </button>
        )}
      </div>
    </header>
  );
};

export default HeaderAccountsPage;
